import { create } from "zustand";
import { immer as immerMiddleware } from "zustand/middleware/immer";
import { Div } from "../components/general/div";

interface State {
  CounselorAvatar: any;
  Settings: any;
  initiateComponents: (components: any) => void;
}

export const useDynamicComponents = create<State>()(
  immerMiddleware((set, get) => ({
    CounselorAvatar: Div,
    Settings: Div,
    initiateComponents: ({ CounselorAvatar, Settings }) => {
      set((state) => {
        state.CounselorAvatar = CounselorAvatar;
        state.Settings = Settings;
      });
    },
  })),
);
